/* eslint-disable */
import React, { useMemo, useRef } from "react";
import ShortModal from "../../../../components/Universal/ShortModal.component";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import ShortLinkCard from "../../../../components/PagesComponents/Organizational/Management/Activities/ShortLinkCard.component";
import ScrollableShortCard from "../../../../components/Universal/ScrollableShortCard.component";
import PollingCard from "../../../../components/PagesComponents/Organizational/Management/Activities/PollingCard.component";
import "../../../../styles/Pages/Organizational/Management/Activities/Activities.style.css";
// icons
import { FaPlus } from "react-icons/fa";
import UpcomingEventsCard from "../../../../components/PagesComponents/Organizational/Management/Activities/UpcomingEventsCard.component";
import PollingProfileStore from "../../../../store/ActivityStore.store";
import CardHeader from "../../../../components/Universal/CardHeader.component";
import DonutChart from "../../../../components/PagesComponents/Organizational/Management/Dashboard/DonutChart.components";
import ScrollableCardTable from "../../../../components/Universal/ScrollableCardTable.component";
import MessageSendCard from "../../../../components/PagesComponents/Organizational/Management/Activities/MessageSendCard.component";
import { Form, Formik } from "formik";
import FormInput from "../../../../components/Universal/FormInput.component";
import CreateMeetings from "../../../../components/PagesComponents/Organizational/Management/Activities/CreateMeetings.componetn";
import CreateEvents from "../../../../components/PagesComponents/Organizational/Management/Activities/CreateEvents.component";
import MeetingDetailsModal from "../../../../components/PagesComponents/Organizational/Management/Activities/MeetingDetailsModal.component";
import EventDetailsModal from "../../../../components/PagesComponents/Organizational/Management/Activities/EventDetailsModal.component";
import SuccessTick from "../../../../assets/Icons/Universal/Tick.svg";
import SecondModal from "../../../../components/Universal/SecondModal.component";
import MessagingFloatingCard from "../../../../components/PagesComponents/Organizational/Management/Activities/Messaging/MessagingFloatingCard.component";
import DropDownInput from "../../../../components/Universal/DropDownInput.component";
import { Helmet } from "react-helmet";
const Body = ({
  donutChartData,
  broadCastMessageTeacherInput,
  broadCastMessageStudentInput,
  setBroadcastMessageInput,
  broadcastMessageInput,
  votePollingFormModal,
  setVotePollingFormModal,
  pollingFormValidation,
  createMeetingsModal,
  setCreateMeetingsModal,
  setMeetingFormData,
  createEventsModal,
  setCreateEventsModal,
  setEventsFormData,
  viewMeetingDetailsModal,
  setViewMeetingDetailsModal,
  eventData,
  handelEventModalFilter,
  eventModalData,
  meetingModalData,
  meetingData,
  handelMeetingModalFilter,
  viewEventDetailsModal,
  setViewEventDetailsModal,
  alertModal,
  setAlertModal,
  promptModal,
  setPromptModal,
  promptModalStatus,
  setPromptModalStatus,
  openMessageHistory,
  setOpenMessageHistory,
  openMessageSentModal,
  setOpenMessageSentModal,
}) => {
  const pollingFormRef = useRef();
  const { setProfileId } = PollingProfileStore();
  const clickProfile = (_id) => {
    console.log(_id);
    setProfileId(_id);
  };
  const totalAppearances = useMemo(() => {
    return donutChartData.reduce((acc, curr) => acc + curr.appearanceCount, 0);
  }, [donutChartData]);

  return (

    <section className="activitiesPage">
      <Helmet>
        <title>Activites</title>
      </Helmet>
      <PageHeader />
      {/* this modal use for adding polling details */}
      <ShortModal
        isOpen={votePollingFormModal}
        onClose={() => setVotePollingFormModal(!votePollingFormModal)}
      >
        <Formik
          initialValues={{
            purpose: "",
            endTime: "",
            endDate: "",
          }}
          validationSchema={pollingFormValidation}
          onSubmit={(values) => {
            console.log(values);
          }}
          innerRef={pollingFormRef}
        >
          {({ touched, errors, handleSubmit }) => {
            return (
              <Form
                action=""
                onSubmit={handleSubmit}
                className="flex-col align-start justify-start w-full g-2"
              >
                <div className="flex-col align-start justify-start w-full g-2">
                  <h3 className="poppins weight-500">Add polling details</h3>
                  <div className="flex-col align-start justify-start w-full g-05">
                    <div className="flex-row align-start justify-start w-full g-05">
                      <FormInput
                        label="Purpose"
                        name="purpose"
                        type="text"
                        touched={touched}
                        errors={errors}
                        placeholder={"Enter a purpose"}
                      />
                      <FormInput
                        label="End Time"
                        name="endTime"
                        type="time"
                        touched={touched}
                        errors={errors}
                        placeholder={"Enter last time of submission"}
                        className={"timeInputField"}
                      />
                      <FormInput
                        label="End Time"
                        name="endDate"
                        type="date"
                        touched={touched}
                        errors={errors}
                        className="dateInputField"
                        placeholder={"Enter last time of submission"}
                      />
                    </div>
                  </div>

                  <div className="flex-col align-start justify-start w-full g-2">
                    <h3
                      className="poppins weight-500"
                      style={{ color: "var(--grayColor)" }}
                    >
                      Add polling details
                    </h3>
                    <div className="pollingFormNominationInputs">
                      <FormInput
                        label="1. Nomination"
                        name="nomination1"
                        type="text"
                        touched={touched}
                        errors={errors}
                        placeholder={"Enter a name"}
                      />
                      <FormInput
                        label="2. Nomination"
                        name="nomination2"
                        type="text"
                        touched={touched}
                        errors={errors}
                        placeholder={"Enter a name"}
                      />
                      <FormInput
                        label="3. Nomination"
                        name="nomination3"
                        type="text"
                        touched={touched}
                        errors={errors}
                        placeholder={"Enter a name"}
                      />
                      <FormInput
                        label="4. Nomination"
                        name="nomination4"
                        type="text"
                        touched={touched}
                        errors={errors}
                        placeholder={"Enter a name"}
                      />
                      <FormInput
                        label="5. Nomination"
                        name="nomination5"
                        type="text"
                        touched={touched}
                        errors={errors}
                        placeholder={"Enter a name"}
                      />
                      <FormInput
                        label="6. Nomination"
                        name="nomination6"
                        type="text"
                        touched={touched}
                        errors={errors}
                        placeholder={"Enter a name"}
                      />
                    </div>
                  </div>
                  <button type="submit" className="memberFormSubmitBtn">
                    Add Details
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </ShortModal>

      {/* this modal use for Send the bordcast masseges to   */}
      {/* this modal use for create new meetings*/}
      <CreateMeetings
        onClose={setCreateMeetingsModal}
        modalStatus={createMeetingsModal}
        setMeetingFormData={(data) => setMeetingFormData(data)}
      />
      {/* this modal use for create new events*/}
      <CreateEvents
        onClose={setCreateEventsModal}
        modalStatus={createEventsModal}
        setEventsFormData={(data) => setEventsFormData(data)}
      />

      <MeetingDetailsModal
        onClose={setViewMeetingDetailsModal}
        modalStatus={viewMeetingDetailsModal}
        data={meetingModalData && meetingModalData}
        handelComplete={(_id) => console.log("mark read", _id)}
        handelDelete={(_id) => console.log("Delete", _id)}
      />
      <EventDetailsModal
        onClose={setViewEventDetailsModal}
        modalStatus={viewEventDetailsModal}
        data={eventModalData && eventModalData}
        handelComplete={(_id) => console.log("mark read", _id)}
        handelDelete={(_id) => console.log("Delete", _id)}
      />

      <SecondModal isOpen={alertModal} onClose={() => setAlertModal(false)}>
        <div
          className="flex-col align-center justify-center g-1"
          style={{ width: "17rem" }}
        >
          <img
            src={SuccessTick}
            alt=""
            style={{ width: "6rem", height: "6rem" }}
          />
          <h3 className="color-success poppins t-16 text-align-center">
            You have deleted <br /> the event successfully
          </h3>
          <button
            className="actionBtn w-full poppins"
            onClick={() => setAlertModal(false)}
          >
            Okay
          </button>
        </div>
      </SecondModal>
      <SecondModal isOpen={promptModal} onClose={() => setPromptModal(false)}>
        <div
          className="flex-col align-center justify-center g-1"
          style={{ width: "20rem" }}
        >
          <h3 className="color-red poppins t-22 text-align-center weight-500">
            Are you sure ?
          </h3>
          <div className="flex-col g-05">
            <h3 className="color-black poppins-medium t-15 text-align-center weight-500">
              You want to delete this event
            </h3>
            <p className="poppins t-12 text-align-center">
              Once you delete this event, will not save or
              <br /> show again in this site
            </p>
          </div>

          <div className="flex-col g-1 w-full">
            <button
              className="actionBtn2 w-full poppins"
              onClick={() => {
                setPromptModal(false);
                setPromptModalStatus(true);
              }}
            >
              Confirm
            </button>
            <button
              className="deleteBtn w-full poppins"
              onClick={() => {
                setPromptModal(false);
                setPromptModalStatus(false);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </SecondModal>

      <ShortModal
        isOpen={openMessageSentModal}
        onClose={() => setOpenMessageSentModal(!openMessageSentModal)}
      >
        <div
          className="flex-col align-center justify-center g-2"
          style={{ width: "20rem" }}
        >
          <h3 className="color-grayBorder poppins t-22 text-align-center weight-500">
            Message to
          </h3>
          <div className="flex-row w-full align-center justify-start g-1">
            {" "}
            <div
              style={{
                width: "3rem",
                height: "3rem",
                borderRadius: "50%",
                backgroundColor: "red",
              }}
            ></div>
            <p
              style={{ fontWeight: "300" }}
              className="poppins-medium weight-500 t-13 text-align-center"
            >
              All teachers
            </p>
          </div>
          <Formik
            initialValues={{
              msg: "",
              specify: "",
            }}
            onSubmit={(values) => {
              console.log(values);
            }}
          >
            {({ touched, errors, setTouched, setFieldValue, submitForm }) => {
              return (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    submitForm();
                  }}
                  className="flex-col align-start justify-start g-1"
                >
                  <DropDownInput
                    name="specify"
                    label="Specify to"
                    setFieldValue={(val) => setFieldValue("specify", val)}
                    placeholder={"Choose specification to"}
                    suggestionList={["test1", "test2", "test3"]}
                    errors={errors}
                    setTouched={(name, isTouched) =>
                      setTouched({ [name]: isTouched })
                    }
                    touched={touched}
                  />

                  <FormInput
                    label="Message"
                    name="msg"
                    type="textarea"
                    placeholder={"Type messages here..."}
                    touched={touched}
                    errors={errors}
                  />
                  <div className="flex-col g-1 w-full">
                    <button
                      className="actionBtn2 w-full poppins"
                      type="submit"
                    >
                      Send
                    </button>
                  </div>
                </form>
              );
            }}
          </Formik>
        </div>
      </ShortModal>
      <button onClick={() => setAlertModal(true)}>modal</button>
      <button onClick={() => setPromptModal(true)}>prompt modal</button>
      <MessagingFloatingCard isMessageOpen={openMessageHistory} />
      <div className="activitiesShortLinksContainer">
        <ShortLinkCard
          title="Online meetings"
          description="Via Google meet"
          path="https://meet.google.com/"
          cardColor="#6b623f"
        />
        <ShortLinkCard
          title="Send messages"
          description="Via Whats app"
          path="https://web.whatsapp.com/"
          cardColor="#586849"
        />
        <ShortLinkCard
          title="Send emails"
          description="Via Gmail"
          path="https://mail.google.com"
          cardColor="#5B6B73"
        />
        <ShortLinkCard
          title="Create forms"
          description="Via Google forms"
          path="https://docs.google.com"
          cardColor="#826584"
        />
      </div>
      <div className="pollingAndEventsContainer">
        <div className="pollingAndEventsContainerLeft">
          <div className="pollingDetailsParentContainer">
            <ScrollableShortCard
              title={"Polling details"}
              actionBtn={
                <button
                  className="actionBtn"
                  onClick={() => setVotePollingFormModal(true)}
                >
                  ADD
                </button>
              }
            >
              {[...Array(10)].map((_, indexKey) => (
                <PollingCard
                  key={indexKey}
                  handleCardClick={() => clickProfile("test")}
                  title={"Creating head master"}
                  date={"12 AM, 02, Nov, 2024"}
                  personName={"Akram Hossain"}
                  pollingId="test"
                />
              ))}
            </ScrollableShortCard>
          </div>

          <div className="eventsContiner">
            <div className="eventContainerLeft">
              {/* for Upcoming Events */}
              <ScrollableShortCard
                title={"Events"}
                actionBtn={
                  <button
                    className="actionBtn2"
                    onClick={() => setCreateEventsModal(true)}
                  >
                    <FaPlus />
                  </button>
                }
              >
                {eventData &&
                  eventData.map((_data) => (
                    <UpcomingEventsCard
                      key={_data._id}
                      eventName={_data.eventName}
                      eventDate={_data.eventDate}
                      handelCardClick={() => {
                        setViewEventDetailsModal(true);
                        handelEventModalFilter(_data._id);
                      }}
                    />
                  ))}
              </ScrollableShortCard>
            </div>
            <div className="eventContainerRight">
              {/* for Upcoming Meetings */}
              <ScrollableShortCard
                title={"Meetings"}
                actionBtn={
                  <button
                    className="actionBtn2"
                    onClick={() => setCreateMeetingsModal(true)}
                  >
                    <FaPlus />
                  </button>
                }
              >
                {meetingData &&
                  meetingData.map((_data) => {
                    return (
                      <UpcomingEventsCard
                        key={_data._id}
                        eventName={_data.subject}
                        eventDate={_data.meetingDate}
                        designation={_data.designation}
                        indicator
                        indicatorColor="orange"
                        handelCardClick={() => {
                          setViewMeetingDetailsModal(true);
                          handelMeetingModalFilter(_data._id);
                        }}
                      />
                    );
                  })}
              </ScrollableShortCard>
            </div>
          </div>
        </div>
        <div className="pollingAndEventsContainerRight">
          <div className="viewPollingDetailsContainer">
            <CardHeader
              title="Polling chart"
              actionBtn={<h3>Creating a head master</h3>}
              headerStyle={{ borderBottom: "none" }}
            />
            <div className="flex-row g-05 space-between w-full h-half flex-1">
              <div className="h-full w-half">
                <DonutChart donutChartData={donutChartData} />
              </div>

              <div className="w-half h-full flex-col align-start justify-start">
                <ScrollableCardTable thead={["Nomination", "Count", "%"]}>
                  {donutChartData &&
                    donutChartData.map((_data, index) => {
                      return (
                        <tr
                          style={{
                            "--pollingDonutChartTableDetailsIndicatorColor":
                              _data.positionColor,
                          }}
                          className="pollingDetailsTableData w-full flex-row align-center justify-arround"
                        >
                          <td
                            style={{
                              width: `calc(100%/${3})`,
                              textAlign: "center",
                            }}
                          >
                            {_data.pollingCandidate}
                          </td>
                          <td
                            style={{
                              width: `calc(100%/${3})`,
                              textAlign: "center",
                            }}
                          >
                            {_data.appearanceCount}
                          </td>
                          <td
                            style={{
                              width: `calc(100%/${3})`,
                              textAlign: "center",
                            }}
                          >
                            {(
                              (_data.appearanceCount / totalAppearances) *
                              100
                            ).toFixed(1)}{" "}
                            %
                          </td>
                        </tr>
                      );
                    })}
                </ScrollableCardTable>
              </div>
            </div>
          </div>
          <div className="broadcastMessagesContainer">
            <CardHeader
              title="Broadcast Messages"
              actionBtn={
                <button
                  className="actionBtn"
                  onClick={() => {
                    // console.log(broadCastMessageTeacherInput.current);
                    if (
                      broadCastMessageTeacherInput &&
                      broadCastMessageStudentInput
                    ) {
                      broadCastMessageStudentInput.current.checked = true;
                      broadCastMessageTeacherInput.current.checked = true;
                      setBroadcastMessageInput({
                        ...broadcastMessageInput,
                        teachers: true,
                        students: true,
                      });
                    }
                  }}
                  title="send message to all teachers and students"
                >
                  Messages to all
                </button>
              }
            />
            <div className="w-full flex-col justify-start align-start g-1 p-r-1">
              <MessageSendCard
                inputRef={broadCastMessageTeacherInput}
                title="All teachers"
                name={"teachers"}
                color="#7BD7CD"
                onChange={(_name, val) =>
                  setBroadcastMessageInput({
                    ...broadcastMessageInput,
                    teachers: val !== "",
                  })
                }
              />
              <MessageSendCard
                inputRef={broadCastMessageStudentInput}
                title="All students"
                name={"students"}
                color="#91B9FA"
                onChange={(_name, val) =>
                  setBroadcastMessageInput({
                    ...broadcastMessageInput,
                    students: val !== "",
                  })
                }
              />
              <div className="w-full flex-col justify-start align-start g-05">
                <button
                  className="actionBtnLight w-full p-t-1 p-b-1"
                  onClick={() => setOpenMessageHistory(!openMessageHistory)}
                >
                  Message history
                </button>
                <button
                  className="actionBtn w-full p-t-1 p-b-1"
                  onClick={() =>
                    setOpenMessageSentModal(!openMessageSentModal)
                  }
                >
                  Write Message
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
